import type { ReactNode } from 'react';

import Stack from '@mui/material/Stack';

import { SingleState } from './SingleState';

interface MixedStateProps {
    validCount: number;
    invalidCount: number;
    missingCount: number;
}

const MixedState = ({
    validCount,
    invalidCount,
    missingCount,
}: MixedStateProps): ReactNode => (
    <Stack
        direction="column"
        spacing={0.5}
        sx={{
            alignItems: 'flex-start',
        }}
    >
        {(validCount > 0 || invalidCount > 0) && (
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    alignItems: 'center',
                }}
            >
                {validCount > 0 && (
                    <SingleState
                        type="valid"
                        count={validCount}
                    />
                )}
                {invalidCount > 0 && (
                    <SingleState
                        type="invalid"
                        count={invalidCount}
                    />
                )}
            </Stack>
        )}
        {missingCount > 0 && (
            <SingleState
                type="missing bom"
                count={missingCount}
            />
        )}
    </Stack>
);

export { MixedState };
